import { getClient } from '@zg-rentals/ts-client-http-client';
import { setClient as setRentalManagerClient } from '@zg-rentals/ts-rental-manager-api-client';
import { setClient as setRentPaymentClient } from '@zg-rentals/ts-rent-payment-client';

export const client = getClient().extend({
  prefixUrl: process.env.NEXT_PUBLIC_RENTAL_MANAGER_PREFIX_URL,
});

setRentalManagerClient(client);

setRentPaymentClient(
  getClient().extend({
    prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX_URL,
  }),
);
